import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ModalVisualizarDocumentos } from "../../../../../components/Generales/ModalVisualizarDocumentos";
import { ModalVisualizarAplicar } from "../../../../../components/Generales/ModalVisualizarAplicar";
import { ModalCondicionesGenerales } from "../../../../../components/Generales/ModalCondicionesGenerales";
import { Button, Empty, Table, Card } from "antd";
import { RootState } from "../../../../../redux/reducers";
import { UseVerConvocatorias } from "../../../../../hooks/UseVerConvocatorias";
import { useNavigate, useLocation } from "react-router-dom";
import "./Information.scss";
import { useEncrypt } from "../../../../../hooks/useEncrypt";
import { openNotification } from "../../../../../utils/Notifactions";
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
import getStorageUser from "../../../../../middlewares/GetStorageUser";
import moment from "moment";
import apiMaestras from "../../../../../api/Maestras/api-maestras";
import { useLanding } from "../../../../../hooks/useLanding";
import { ReactComponent as DownloadIcon } from "../../../../../assets/download-detail.svg";
import { ReactComponent as EyeIcon } from "../../../../../assets/eye-detail.svg";
import ImageNotFound from "../../../../../assets/enmascarar-detail.png";
import apiDocumentos from "../../../../../api/Documentos/api-documentos";
import apiParticipantes from "../../../../../api/Participantes/api-participantes";
import axios from "axios";
import html2canvas from "html2canvas";
import { ObjNotificaciones } from "../../../../../config/notificaciones";
import { fechaCierre, momentCierre } from "../../../../../utils/horaCierre";
import { FORMULARIOS_EN_LINEA } from "../../../../../utils/documentosGrupoConformado";

// Iconos para perfiles de participante
const PersonIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const GroupIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const BuildingIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <path d="M3 10h18" />
    <path d="M5 6l7-3 7 3" />
    <path d="M4 10v11" />
    <path d="M20 10v11" />
    <path d="M8 14v4" />
    <path d="M12 14v4" />
    <path d="M16 14v4" />
  </svg>
);

const FormPencilIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const ClipDocIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  </svg>
);

// Helper para resolver el tabId admitiendo nombres canónicos y alias amigables en la URL
export const resolveTabId = (rawTab: string | null | undefined): string | null => {
  if (!rawTab) return null;
  const cleanTab = rawTab.trim().toLowerCase().replace(/^#/, "");

  const validIds = [
    "resumen",
    "quien_participa",
    "categorias",
    "requisitos",
    "cronograma",
    "documentos",
    "informes",
  ];
  if (validIds.includes(cleanTab)) return cleanTab;

  const aliasMap: Record<string, string> = {
    "quien-participa": "quien_participa",
    "quienparticipa": "quien_participa",
    "participantes": "quien_participa",
    "participa": "quien_participa",
    "categorias": "categorias",
    "categoria": "categorias",
    "que-necesito": "requisitos",
    "que_necesito": "requisitos",
    "requisito": "requisitos",
    "documentos-generales": "documentos",
    "documentos_generales": "documentos",
    "anexos": "documentos",
    "fechas": "cronograma",
    "cronogramas": "cronograma",
    "informes-y-avisos": "informes",
    "informes_avisos": "informes",
    "avisos": "informes",
  };

  return aliasMap[cleanTab] || null;
};

interface IProps {
  convocatorias: any;
  isVisualizar?: boolean;
}

export const Information: React.FC<IProps> = (props: IProps) => {
  const { getConvocatorias } = useLanding();
  const [calculateDayEnd, setCalculateDayEnd] = useState<any>();
  const [calculateDayStart, setCalculateDayStart] = useState<any>();
  const [dataImg, setDataImg] = useState<any>();
  const [user, setUser] = useState<any>({});
  const navigate = useNavigate();
  const location = useLocation();
  const { inscribirPropuesta, descargarArchivo, loading } = UseVerConvocatorias();
  const { encrypt } = useEncrypt();
  const [LineasConvocatorias, setLineasConvocatorias] = useState<any[]>([]);

  // Inicializar tab activo desde ?tab= o #hash de la URL para deep-linking
  const getInitialTab = (): string => {
    try {
      const tabParam = new URLSearchParams(window.location.search).get("tab");
      const hashParam = window.location.hash.replace(/^#/, "");
      return resolveTabId(tabParam) || resolveTabId(hashParam) || "resumen";
    } catch {
      return "resumen";
    }
  };

  const [activeTab, setActiveTab] = useState<string>(getInitialTab);

  const updateTabUrl = (tabId: string) => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", tabId);
      window.history.replaceState(null, "", url.toString());
    } catch {
      // Ignorar si el entorno no lo soporta
    }
  };

  // Sincronizar activeTab cuando el usuario navega con botones atrás/adelante del navegador
  useEffect(() => {
    const handlePopState = () => {
      try {
        const tabParam = new URLSearchParams(window.location.search).get("tab");
        const hashParam = window.location.hash.replace(/^#/, "");
        const resolved = resolveTabId(tabParam) || resolveTabId(hashParam);
        if (resolved) {
          setActiveTab(resolved);
        }
      } catch {}
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);
  const [isSaved, setIsSaved] = useState<boolean>(false);
  const [selectedPersona, setSelectedPersona] = useState<string>("0");

  const { idParticipante } = useSelector(
    (state: RootState) => state.participantes
  );

  const [visualizarDocument, setVisualizarDocument] = useState<boolean>(false);
  const [urldocumento, setUrldocumento] = useState<string>("");
  const [visualizarAplicar, setVisualizarAplicar] = useState<boolean>(false);
  // Modal de condiciones inicia cerrado para no bloquear la pantalla en tabloide
  const [visualizarCondiciones, setVisualizarCondiciones] = useState<boolean>(false);
  const [loadingAplicar, setLoadingAplicar] = useState<boolean>(false);
  const [loadingDoc, setLoadingDoc] = useState<string | null>(null);
  const [isGeneratingCronogramaImg, setIsGeneratingCronogramaImg] = useState<boolean>(false);
  const cronogramaTemplateRef = React.useRef<HTMLDivElement>(null);

  // Cuenta regresiva para cierre
  const [timeRemaining, setTimeRemaining] = useState({
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isFinished: false,
    hasStarted: false,
  });

  useEffect(() => {
    if (!calculateDayEnd) return;

    const updateCountdown = () => {
      const now = moment();
      const targetCierre = momentCierre(calculateDayEnd);
      const diff = targetCierre.diff(now);

      if (diff <= 0) {
        setTimeRemaining({
          months: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          isFinished: true,
          hasStarted: true,
        });
        return;
      }

      const duration = moment.duration(diff);
      setTimeRemaining({
        months: duration.months(),
        days: duration.days(),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
        isFinished: false,
        hasStarted: true,
      });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [calculateDayEnd]);

  const handleVerDocumento = async (url: string, nombreDoc?: string) => {
    if (!url) return;

    // Si es enlace externo HTTP/HTTPS o blob, abrir directamente en pestaña
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("blob:")) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }

    const isMobile =
      typeof window !== "undefined" &&
      (window.innerWidth <= 992 ||
        "ontouchstart" in window ||
        (navigator && navigator.maxTouchPoints > 0) ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || ""));

    // En DESKTOP: Abrir el modal habitual de previsualización
    if (!isMobile) {
      setUrldocumento(url);
      visualizarModal();
      return;
    }

    // En MOBILE: obtener el archivo vía API y abrirlo en una nueva pestaña.
    //
    // Safari (iOS) bloquea window.open() si se llama DESPUÉS de un await, porque
    // ya no está dentro del gesto del clic (Chrome es más permisivo). Por eso la
    // pestaña se abre de forma síncrona aquí y, cuando el archivo está listo, se
    // la apunta al Blob.
    const extension = String(url).split(".").pop()?.toLowerCase() ?? "";
    const esOffice = ["doc", "docx", "xls", "xlsx"].includes(extension);
    // Los de Office se descargan (no se previsualizan), así que no abren pestaña.
    const nuevaPestana = esOffice ? null : window.open("", "_blank");

    setLoadingDoc(url);
    try {
      const response: any = await apiDocumentos.consultarArchivo(url);
      if (!response || !response.data) {
        throw new Error("No se pudo obtener el archivo");
      }

      let mime = "application/pdf";
      if (extension === "doc" || extension === "docx") {
        mime = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (extension === "xls" || extension === "xlsx") {
        mime = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      }

      const blob = new Blob([response.data], { type: mime });
      const blobUrl = URL.createObjectURL(blob);

      if (esOffice) {
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", nombreDoc || url.split("/").pop() || "documento");
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
        return;
      }

      // PDF: apuntar la pestaña ya abierta al Blob. Si el navegador la bloqueó
      // (nuevaPestana es null), se intenta con un enlace como último recurso.
      if (nuevaPestana) {
        nuevaPestana.location.href = blobUrl;
      } else {
        const link = document.createElement("a");
        link.href = blobUrl;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
      }
    } catch (error) {
      console.error("Error cargando documento:", error);
      // Si abrimos una pestaña en blanco y el archivo falló, la cerramos.
      if (nuevaPestana) nuevaPestana.close();
      openNotification({
        titulo: "Error al cargar documento",
        descripcion: "No se pudo obtener el archivo solicitado. Intenta descargarlo con el botón de descarga.",
        placement: "bottomRight",
      });
    } finally {
      setLoadingDoc(null);
    }
  };

  const handleDescargarCronogramaImagen = async () => {
    if (!cronogramaTemplateRef.current) return;
    setIsGeneratingCronogramaImg(true);

    try {
      const canvas = await html2canvas(cronogramaTemplateRef.current, {
        scale: 2.2,
        useCORS: true,
        logging: false,
        backgroundColor: "#071e36",
        windowWidth: 480,
      });

      const lineaNombre =
        getFilterLineaConvocatoria(props.convocatorias?.linea_convocatoria) ||
        props.convocatorias?.linea_estrategica ||
        props.convocatorias?.nombre_convocatoria ||
        "Convocatoria";

      const cleanLinea = (lineaNombre || "Cronograma")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]/g, "_")
        .slice(0, 40);

      const filename = `Cronograma_${cleanLinea}.png`;

      // Si el navegador móvil soporta Web Share API con archivos (Android/iOS)
      if (typeof navigator !== "undefined" && navigator.share && navigator.canShare) {
        try {
          const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/png"));
          if (blob) {
            const file = new File([blob], filename, { type: "image/png" });
            if (navigator.canShare({ files: [file] })) {
              await navigator.share({
                files: [file],
                title: `Cronograma - ${lineaNombre}`,
                text: `Cronograma de actividades: ${props.convocatorias?.nombre_convocatoria || lineaNombre}`,
              });
              setIsGeneratingCronogramaImg(false);
              return;
            }
          }
        } catch (shareErr) {
          if ((shareErr as Error)?.name === "AbortError") {
            setIsGeneratingCronogramaImg(false);
            return;
          }
        }
      }

      // Descarga directa en navegador
      const dataUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.download = filename;
      link.href = dataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      openNotification({
        titulo: "Imagen descargada",
        descripcion: "El cronograma en formato para celular se ha descargado exitosamente.",
        placement: "bottomRight",
      });
    } catch (error) {
      console.error("Error al generar imagen de cronograma:", error);
      openNotification({
        titulo: "Error al generar imagen",
        descripcion: "No se pudo generar la imagen del cronograma. Por favor intenta nuevamente.",
        placement: "bottomRight",
      });
    } finally {
      setIsGeneratingCronogramaImg(false);
    }
  };

  const findDocumentoForActividad = (actividadClave: string) => {
    const docs = props.convocatorias?.documentos_generales;
    if (!docs || !Array.isArray(docs) || !actividadClave) return null;

    const clean = (s: string) =>
      (s || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]/g, " ")
        .trim();

    const cNorm = clean(actividadClave);

    // 1. Coincidencia directa
    for (const doc of docs) {
      if (!doc.url_documento) continue;
      const descNorm = clean(doc.descripcion);
      const nomNorm = clean(doc.nombre);

      if (
        (descNorm && (descNorm.includes(cNorm) || cNorm.includes(descNorm))) ||
        (nomNorm && (nomNorm.includes(cNorm) || cNorm.includes(nomNorm)))
      ) {
        return doc;
      }
    }

    // 2. Coincidencias por palabras clave semánticas
    if (cNorm.includes("propuestas inscritas")) {
      const match = docs.find((d: any) => {
        const text = clean(d.descripcion) + " " + clean(d.nombre);
        return text.includes("inscritas");
      });
      if (match?.url_documento) return match;
    }

    if (cNorm.includes("primer informe") && cNorm.includes("verificacion")) {
      const match = docs.find((d: any) => {
        const text = clean(d.descripcion) + " " + clean(d.nombre);
        return (text.includes("primer") || text.includes("1")) && text.includes("verificacion");
      });
      if (match?.url_documento) return match;
    }

    if (cNorm.includes("informe final") && cNorm.includes("verificacion")) {
      const match = docs.find((d: any) => {
        const text = clean(d.descripcion) + " " + clean(d.nombre);
        return text.includes("final") && text.includes("verificacion");
      });
      if (match?.url_documento) return match;
    }

    if (cNorm.includes("informe") && cNorm.includes("evaluacion")) {
      const match = docs.find((d: any) => {
        const text = clean(d.descripcion) + " " + clean(d.nombre);
        return text.includes("evaluacion") && !text.includes("observacion");
      });
      if (match?.url_documento) return match;
    }

    if (cNorm.includes("elegible") || cNorm.includes("pulep")) {
      const match = docs.find((d: any) => {
        const text = clean(d.descripcion) + " " + clean(d.nombre);
        return text.includes("elegible") || text.includes("pulep");
      });
      if (match?.url_documento) return match;
    }

    if (cNorm.includes("observacion")) {
      const match = docs.find((d: any) => {
        const text = clean(d.descripcion) + " " + clean(d.nombre);
        return text.includes("observacion");
      });
      if (match?.url_documento) return match;
    }

    if (cNorm.includes("resolucion") || cNorm.includes("otorgamiento")) {
      const match = docs.find((d: any) => {
        const text = clean(d.descripcion) + " " + clean(d.nombre);
        return text.includes("resolucion") || text.includes("otorgamiento") || d.tipo_documento === "Resolución";
      });
      if (match?.url_documento) return match;
    }

    return null;
  };

  const getEtapaCronograma = (clave: string): "apertura" | "verificacion" | "evaluacion" => {
    const norm = (clave || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    if (
      norm.includes("verificacion") ||
      norm.includes("subsanar") ||
      norm.includes("subsanacion")
    ) {
      return "verificacion";
    }

    if (
      norm.includes("evaluacion") ||
      norm.includes("jurado") ||
      norm.includes("inhabilidad") ||
      norm.includes("elegible") ||
      norm.includes("ministerio") ||
      norm.includes("resolucion") ||
      norm.includes("otorgamiento") ||
      norm.includes("ganador")
    ) {
      return "evaluacion";
    }

    return "apertura";
  };

  const capitalizeFirst = (s: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");

  const formatFechaCronograma = (item: any) => {
    const minM = moment(item.valormin);
    if (!minM.isValid()) return item.valormin || "";

    const maxM = item.valormax && moment(item.valormax).isValid() ? moment(item.valormax) : null;
    const showHora = item.clave === "Cierre" || (item.clave && item.clave.toLowerCase().includes("subsanar"));
    const hora = showHora
      ? item.clave === "Cierre"
        ? momentCierre(item.valormax || item.valormin).format("h:mm a")
        : minM.format("h:mm a")
      : "";

    if (maxM && maxM.format("YYYY-MM-DD") !== minM.format("YYYY-MM-DD")) {
      const minDayStr = minM.format("dddd D");
      const maxFullStr = maxM.format("dddd D [de] MMMM [de] YYYY");
      let result = `${capitalizeFirst(minDayStr)} y ${maxFullStr}`;
      if (hora) {
        result += ` hasta las ${hora}`;
      }
      return result;
    }

    let result = capitalizeFirst(minM.format("dddd D [de] MMMM [de] YYYY"));
    if (hora) {
      result += ` a las ${hora}`;
    }
    return result;
  };

  // Control dinámico de scroll para tabs en mobile
  const tabsContainerRef = React.useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState<boolean>(false);
  const [canScrollRight, setCanScrollRight] = useState<boolean>(false);

  const checkScroll = () => {
    if (tabsContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = tabsContainerRef.current;
      setCanScrollLeft(scrollLeft > 6);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 6);
    }
  };

  const scrollToTab = (targetButton: HTMLElement | null) => {
    if (!tabsContainerRef.current || !targetButton) return;
    const container = tabsContainerRef.current;

    const containerWidth = container.clientWidth;
    const buttonLeft = targetButton.offsetLeft;
    const buttonWidth = targetButton.offsetWidth;

    // Centrar suavemente la pestaña seleccionada en el contenedor visible
    const targetScrollLeft = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
    const maxScroll = Math.max(0, container.scrollWidth - containerWidth);
    const clampedScroll = Math.max(0, Math.min(targetScrollLeft, maxScroll));

    if (typeof container.scrollTo === "function") {
      container.scrollTo({
        left: clampedScroll,
        behavior: "smooth",
      });
    } else {
      container.scrollLeft = clampedScroll;
    }

    setTimeout(checkScroll, 320);
  };

  const handleTabClick = (tabId: string, e?: React.MouseEvent<HTMLButtonElement>) => {
    // 1. Cambio de pestaña inmediato en 1 solo clic
    setActiveTab(tabId);
    // 2. Actualizar la URL de forma limpia y compartible sin re-renderizar la ruta
    updateTabUrl(tabId);
    // 3. Centrar el botón presionado suavemente para revelar opciones adyacentes
    if (e?.currentTarget) {
      scrollToTab(e.currentTarget);
    }
  };

  const scrollTabs = (direction: "left" | "right") => {
    if (tabsContainerRef.current) {
      const offset = direction === "left" ? -180 : 180;
      if (typeof tabsContainerRef.current.scrollBy === "function") {
        tabsContainerRef.current.scrollBy({ left: offset, behavior: "smooth" });
      } else {
        tabsContainerRef.current.scrollLeft += offset;
      }
      setTimeout(checkScroll, 320);
    }
  };

  useEffect(() => {
    checkScroll();
    const timer = setTimeout(checkScroll, 250);
    window.addEventListener("resize", checkScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  // Centrar automáticamente la pestaña activa al cargar la página (o compartir enlace directo)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabsContainerRef.current) {
        const activeBtn = tabsContainerRef.current.querySelector<HTMLButtonElement>(".tab-nav-button.active");
        if (activeBtn) {
          scrollToTab(activeBtn);
        }
        checkScroll();
      }
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    getConvocatorias();
    getLineasConvocatorias();
    const token = localStorage.getItem("token");
    if (token) {
      getUser();
    }
  }, []);

  useEffect(() => {
    try {
      const id = props.convocatorias?.idconvocatorias;
      if (id) {
        const guardadas = JSON.parse(localStorage.getItem("guardadas_convocatorias") || "[]");
        setIsSaved(guardadas.includes(id));
      }
    } catch {
      // Ignorar error de parsing
    }
  }, [props.convocatorias?.idconvocatorias]);

  const toggleGuardar = () => {
    try {
      const id = props.convocatorias?.idconvocatorias;
      if (!id) return;
      const guardadas = JSON.parse(localStorage.getItem("guardadas_convocatorias") || "[]");
      let actualizadas: number[];
      if (guardadas.includes(id)) {
        actualizadas = guardadas.filter((x: number) => x !== id);
        setIsSaved(false);
        openNotification({
          titulo: "Convocatoria retirada",
          descripcion: "La convocatoria se retiró de tus guardadas",
          placement: "bottomRight",
        });
      } else {
        actualizadas = [...guardadas, id];
        setIsSaved(true);
        openNotification({
          titulo: "Convocatoria guardada",
          descripcion: "La convocatoria fue guardada en tus favoritas",
          placement: "bottomRight",
        });
      }
      localStorage.setItem("guardadas_convocatorias", JSON.stringify(actualizadas));
    } catch {
      // Ignorar error
    }
  };

  const getImageConvocatoria = async () => {
    if (props.convocatorias?.portada_url) {
      const data = await apiDocumentos.consultarArchivo(props.convocatorias?.portada_url);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setDataImg(base64String);
        };
      }
    }
  };

  const getLineasConvocatorias = async () => {
    try {
      const data = await apiMaestras.obtenerLineaConvocatoria();
      setLineasConvocatorias(data || []);
    } catch (error) {
      setLineasConvocatorias([]);
    }
  };

  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    if (!LineasConvocatorias || !LineasConvocatorias.length) return "";
    const valueFilter = LineasConvocatorias.filter(
      (x: any) => x.id === idLineaConvocatoria || x.idlineaconvocatoria === idLineaConvocatoria
    );
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    }
    return "";
  };

  const getUser = async () => {
    try {
      const u = getStorageUser();
      return setUser(u);
    } catch (error) {
      console.log(error);
    }
  };

  const calculateDate = (fechas: any) => {
    if (fechas !== null && fechas && fechas.length > 0) {
      const filterDateStart = fechas.filter((data: any) => data.clave === "Apertura");
      const filterDateEnd = fechas.filter((data: any) => data.clave === "Cierre");

      if (filterDateStart.length > 0) {
        setCalculateDayStart(moment(filterDateStart[0].valormin));
      }

      if (filterDateEnd.length > 0) {
        if (filterDateEnd[0].valormax && moment(filterDateEnd[0].valormax).isValid()) {
          setCalculateDayEnd(moment(filterDateEnd[0].valormax));
        } else {
          setCalculateDayEnd(moment(filterDateEnd[0].valormin));
        }
      }
    }
  };

  useEffect(() => {
    getImageConvocatoria();
    calculateDate(props.convocatorias?.fechas);
  }, [props.convocatorias]);

  // Validaciones y postulación manteniendo if condicionales
  const insrcribirme = async () => {
    setLoadingAplicar(true);
    try {
      const token = localStorage.getItem("token");
      const validateToken = await axios.get(`${process.env.REACT_APP_SERVER_USERS}users/token/${token}`);

      if (validateToken?.data?.status !== 200 && token !== "") {
        navigate("/login");
        ObjNotificaciones.MSG_ERROR("warning", "Sesión expirada", "Tú sesión ha expirado, intenta iniciar sesión nuevamente");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }

      let fechaActual = new Date();
      let anio = fechaActual.getFullYear();
      let mes = ("0" + (fechaActual.getMonth() + 1)).slice(-2);
      let dia = ("0" + fechaActual.getDate()).slice(-2);
      let hora = ("0" + fechaActual.getHours()).slice(-2);
      let minutos = ("0" + fechaActual.getMinutes()).slice(-2);
      let fechaYHora = anio + "-" + mes + "-" + dia + " " + hora + ":" + minutos;

      const fechasCierreArr = props.convocatorias?.fechas?.filter((data: any) => data.clave === "Cierre") || [];
      const cierre = fechasCierreArr[0]?.valormax || fechasCierreArr[0]?.valormin;
      let cierreAct = fechaCierre(cierre);

      let anioc = cierreAct.getFullYear();
      let mesc = ("0" + (cierreAct.getMonth() + 1)).slice(-2);
      let diac = ("0" + cierreAct.getDate()).slice(-2);
      let horac = ("0" + cierreAct.getHours()).slice(-2);
      let minutosc = ("0" + cierreAct.getMinutes()).slice(-2);

      let fechaYHoraActualizada = anioc + "-" + mesc + "-" + diac + " " + horac + ":" + minutosc;

      if (fechaYHoraActualizada <= fechaYHora) {
        openNotification({
          titulo: "Error",
          descripcion: "No puedes inscribirte a una convocatoria que no esté abierta",
          placement: "bottomRight",
        });
        setLoadingAplicar(false);
        return navigate("/usuario");
      }

      if (!props.convocatorias?.fechas?.length) {
        openNotification({
          titulo: "Error",
          descripcion: "No puedes inscribirte a una convocatoria que no esté abierta",
          placement: "bottomRight",
        });
        setLoadingAplicar(false);
        return navigate("/usuario");
      }

      const { data } = await apiConvocatorias.obtenerConvocatoriaConEstado(props.convocatorias.idconvocatorias);
      if (data === "En espera" || data === "En proceso" || data === "Cerrada" || data === "No publicada") {
        openNotification({
          titulo: "Error",
          descripcion: "No puedes inscribirte a una convocatoria que no esté abierta",
          placement: "bottomRight",
        });
        setLoadingAplicar(false);
        return navigate("/usuario");
      }

      localStorage.removeItem("id_postulacion");
      localStorage.setItem("idConvocatoriaPostulacion", encrypt(props.convocatorias.idconvocatorias.toString()));

      const loginRoutes: Record<number, string> = {
        1: `/login/1/${props.convocatorias.idconvocatorias}`,
        2: `/login/3/${props.convocatorias.idconvocatorias}`,
        3: `/login/1/${props.convocatorias.idconvocatorias}`,
      };
      if (user === null || !token) {
        const loginRoute = loginRoutes[props.convocatorias.tipo];
        setLoadingAplicar(false);
        if (loginRoute) return navigate(loginRoute);
      }

      const validatePostulacion = await apiParticipantes.validarPostulacion(
        Number(props.convocatorias.idconvocatorias),
        user?.documento?.toString()
      );

      const misPostRoutes: Record<number, string> = {
        1: "/usuario/Mispostulaciones",
        2: "/usuario/MenuJurado",
        3: "/usuario/Mispostulaciones",
      };
      if (validatePostulacion?.data !== null) {
        openNotification({
          titulo: "¡Ya tienes una postulación activa a esta convocatoria",
          descripcion: "Por favor, gestiona tu postulación desde mis proyectos",
          placement: "bottomRight",
        });
        setLoadingAplicar(false);
        const misPostRoute = misPostRoutes[props.convocatorias.tipo];
        if (misPostRoute) return navigate(misPostRoute);
      }

      const finalRoutes: Record<number, string> = {
        1: "/usuario/Seleccionarrol",
        2: "/usuario/Inscribirhojadevida",
        3: "/usuario/Seleccionarrol",
      };
      const finalRoute = finalRoutes[props.convocatorias.tipo];
      if (finalRoute) {
        inscribirPropuesta(props.convocatorias, idParticipante);
        setLoadingAplicar(false);
        return navigate(finalRoute);
      }
    } catch (error) {
      console.error(error);
      setLoadingAplicar(false);
      mostrarModalAplicar();
      navigate("/login");
      ObjNotificaciones.MSG_ERROR("warning", "Sesión expirada", "Tú sesión ha expirado, intenta iniciar sesión nuevamente");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };

  const visualizarModal = () => {
    setVisualizarDocument(true);
  };

  const mostrarModalAplicar = () => {
    setVisualizarAplicar(true);
  };

  const mostrarModalCondiciones = () => {
    setVisualizarCondiciones(true);
  };

  const getDocExtension = (url?: string, nombre?: string, descripcion?: string): string => {
    const target = (url || nombre || descripcion || "").toLowerCase();
    if (target.includes(".docx")) return "DOCX";
    if (target.includes(".doc")) return "DOC";
    if (target.includes(".xlsx")) return "XLSX";
    if (target.includes(".xls")) return "XLS";
    if (target.includes(".pdf")) return "PDF";
    if (target.includes(".zip")) return "ZIP";
    if (target.includes(".rar")) return "RAR";
    return "PDF";
  };

  const renderDocumentCards = (
    docs: any[],
    emptyMessage: string,
    subtituloVacio: string = "Los documentos oficiales estarán disponibles aquí conforme avance la convocatoria.",
    extraAction?: React.ReactNode
  ) => {
    if (!docs || docs.length === 0) {
      return (
        <div className="modern-docs-container">
          <div className="modern-doc-empty-state">
            <div className="empty-icon-circle" aria-hidden="true">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="9" y1="15" x2="15" y2="15" />
              </svg>
            </div>
            <p className="empty-text-main">{emptyMessage}</p>
            <p className="empty-text-sub">{subtituloVacio}</p>
            {extraAction && <div className="empty-extra-action">{extraAction}</div>}
          </div>
        </div>
      );
    }

    return (
      <div className="modern-docs-container">
        <div className="modern-docs-list">
          {docs.map((doc: any, index: number) => {
            const docTitle = doc.descripcion || doc.nombre || `Documento ${index + 1}`;
            const url = doc.url_documento || "";
            const extension = getDocExtension(url, doc.nombre, doc.descripcion);
            const isDownloading = (loading && (loading[doc.nombre] || (doc.descripcion && loading[doc.descripcion]))) || false;
            const isViewing = loadingDoc === url;

            return (
              <div key={doc.id || `${url}-${index}`} className="modern-doc-card">
                <div className="modern-doc-main">
                  <div className={`modern-doc-icon-wrap file-${extension.toLowerCase()}`} aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="16" y1="13" x2="8" y2="13" />
                      <line x1="16" y1="17" x2="8" y2="17" />
                    </svg>
                    <span className="modern-doc-ext-tag">{extension}</span>
                  </div>

                  <div className="modern-doc-content">
                    <div className="modern-doc-title-row">
                      <h4 className="modern-doc-title" title={docTitle}>
                        {docTitle}
                      </h4>
                    </div>

                    <div className="modern-doc-badges">
                      {doc.tipo_documento && (
                        <span className="modern-doc-badge type-badge">{doc.tipo_documento}</span>
                      )}
                      <span className={`modern-doc-badge ext-badge ext-${extension.toLowerCase()}`}>{extension}</span>
                      {doc.fecha_creacion && moment(doc.fecha_creacion).isValid() && (
                        <span className="modern-doc-badge date-badge">
                          Publicado: {moment(doc.fecha_creacion).format("D/MM/YYYY")}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="modern-doc-actions">
                  <button
                    type="button"
                    className="btn-doc-view"
                    onClick={() => handleVerDocumento(url, doc.nombre || doc.descripcion)}
                    disabled={!url || isViewing}
                    title="Visualizar documento"
                  >
                    {isViewing ? (
                      <>
                        <span className="btn-spinner" />
                        <span>Abriendo...</span>
                      </>
                    ) : (
                      <>
                        <EyeIcon />
                        <span>Ver</span>
                      </>
                    )}
                  </button>

                  <button
                    type="button"
                    className="btn-doc-download"
                    onClick={() => descargarArchivo(url, doc.nombre || doc.descripcion)}
                    disabled={!url || isDownloading}
                    title="Descargar documento"
                  >
                    {isDownloading ? (
                      <>
                        <span className="btn-spinner" />
                        <span>Descargando...</span>
                      </>
                    ) : (
                      <>
                        <DownloadIcon />
                        <span>Descargar</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {extraAction && <div className="modern-doc-extra-action-wrap">{extraAction}</div>}
      </div>
    );
  };

  const formulariosEnLinea = FORMULARIOS_EN_LINEA;

  const CORREO_ATENCION: Record<string, string> = {
    SM: "reconocimientomujeres@medellin.gov.co",
    SCC: "convocatorias.cultura@medellin.gov.co",
    PP: "convocatoriaspdlyppcultura@medellin.gov.co",
    "AGENDA PP": "agendaculturalpdlypp@medellin.gov.co",
  };
  const correoAtencion = CORREO_ATENCION[props.convocatorias?.entidad];

  const TITULO_OBJETO: Record<string, string> = {
    SM: "¿Por qué lo hacemos?",
    SCC: "Objeto",
    PP: "Objeto",
    MCM: "Objeto",
  };
  const tituloObjeto = TITULO_OBJETO[props.convocatorias?.entidad ?? ""] || "Objeto";

  // Estado calculado
  const getStatusConvocatoria = () => {
    if (!props.convocatorias) return { label: "En espera", classKey: "espera" };
    if (props.convocatorias.publico === false) {
      return { label: "No publicada", classKey: "no-publicada" };
    }
    if (props.convocatorias.estado && props.convocatorias.estado !== "") {
      const lower = props.convocatorias.estado.toLowerCase();
      if (lower.includes("abierta")) return { label: "Abierta", classKey: "abierta" };
      if (lower.includes("cerrada")) return { label: "Cerrada", classKey: "cerrada" };
      if (lower.includes("espera")) return { label: "En espera", classKey: "espera" };
      return { label: props.convocatorias.estado, classKey: "abierta" };
    }
    if (!props.convocatorias.fechas || props.convocatorias.fechas.length === 0) {
      return { label: "En espera", classKey: "espera" };
    }

    const fechaActual = moment();
    const calcFechaValida = (f: any) =>
      moment(f.valormax).isValid() ? moment(f.valormax) : moment(f.valormin);

    const apertura = props.convocatorias.fechas.find((f: any) => f.clave === "Apertura");
    if (apertura && fechaActual.isBefore(moment(apertura.valormin))) {
      return { label: "En espera", classKey: "espera" };
    }

    const cierre = props.convocatorias.fechas.find((f: any) => f.clave === "Cierre");
    if (cierre && fechaActual.isSameOrAfter(calcFechaValida(cierre))) {
      return { label: "Cerrada", classKey: "cerrada" };
    }

    const resolucion = props.convocatorias.fechas.find((f: any) => f.clave === "Resolución de otorgamiento");
    if (resolucion && fechaActual.isSameOrAfter(calcFechaValida(resolucion))) {
      return { label: "Cerrada", classKey: "cerrada" };
    }

    return { label: "Abierta", classKey: "abierta" };
  };

  const statusInfo = getStatusConvocatoria();

  // Expresión calculada (reemplazando "área" por "expresión" según instrucción)
  const getExpresionTexto = () => {
    if (props.convocatorias?.area && props.convocatorias.area.length > 0) {
      return props.convocatorias.area.map((a: any) => a.text).join(", ");
    }
    return null;
  };

  // Línea estratégica calculada
  const getLineaEstrategicaTexto = () => {
    if (props.convocatorias?.linea_estrategica && String(props.convocatorias.linea_estrategica).trim() !== "") {
      return props.convocatorias.linea_estrategica;
    }
    const linea = getFilterLineaConvocatoria(props.convocatorias?.linea_convocatoria);
    if (linea && String(linea).trim() !== "") return linea;
    return null;
  };

  const expresionVal = getExpresionTexto();
  const lineaEstrategicaVal = getLineaEstrategicaTexto();
  const entidadVal = props.convocatorias?.entidad;

  // Título principal (línea de convocatoria) y subtítulo (nombre_convocatoria e.g. "5ta Convocatoria")
  const lineaConvocatoriaNombre =
    getFilterLineaConvocatoria(props.convocatorias?.linea_convocatoria) ||
    props.convocatorias?.linea_estrategica;
  const tituloPrincipal =
    lineaConvocatoriaNombre || props.convocatorias?.nombre_convocatoria || "Detalle de convocatoria";
  const subtitulo =
    lineaConvocatoriaNombre &&
    props.convocatorias?.nombre_convocatoria &&
    props.convocatorias.nombre_convocatoria !== lineaConvocatoriaNombre
      ? props.convocatorias.nombre_convocatoria
      : null;

  // Fechas de Cierre
  const cierreItem = props.convocatorias?.fechas?.find((f: any) => f.clave === "Cierre");
  const cierreMoment = cierreItem
    ? moment(cierreItem.valormax && moment(cierreItem.valormax).isValid() ? cierreItem.valormax : cierreItem.valormin)
    : null;
  const fechaCierreLegible = cierreMoment && cierreMoment.isValid()
    ? cierreMoment.format("D [de] MMMM [de] YYYY")
    : null;
  const fechaCierreCompact = cierreMoment && cierreMoment.isValid()
    ? cierreMoment.format("D MMM YYYY")
    : null;
  const horaCierreLegible = cierreItem && cierreItem.valormax && moment(cierreItem.valormax).isValid()
    ? momentCierre(cierreItem.valormax).format("h:mm a")
    : null;

  // Fechas ordenadas para cronograma e hitos
  const fechasOrdenadas = (props.convocatorias?.fechas || [])
    .slice()
    .sort((a: any, b: any) => {
      const dateA = +new Date(a.valormin);
      const dateB = +new Date(b.valormin);
      if (isNaN(dateA) && isNaN(dateB)) return 0;
      if (isNaN(dateA)) return 1;
      if (isNaN(dateB)) return -1;
      return dateA - dateB;
    });

  const now = moment();
  const getFechaMoment = (f: any) => {
    if (!f) return moment.invalid();
    if (f.clave === "Cierre") {
      return f.valormax && moment(f.valormax).isValid()
        ? momentCierre(f.valormax)
        : momentCierre(f.valormin);
    }
    return f.valormax && moment(f.valormax).isValid() ? moment(f.valormax) : moment(f.valormin);
  };

  const hitoProximo = fechasOrdenadas.find((f: any) => {
    const m = getFechaMoment(f);
    return m.isValid() && now.isBefore(m);
  });
  const hitoUltimo = fechasOrdenadas[fechasOrdenadas.length - 1];
  const hitoDestacado = hitoProximo || hitoUltimo;
  const esHitoFuturo = hitoProximo != null;
  const hitoTitulo = esHitoFuturo ? "Próximo hito:" : "Último hito:";
  const hitoNombre = hitoDestacado?.clave || "Cierre";
  const hitoFechaObj = hitoDestacado ? getFechaMoment(hitoDestacado) : null;
  const hitoFechaStr = hitoFechaObj && hitoFechaObj.isValid()
    ? capitalizeFirst(hitoFechaObj.format("dddd D [de] MMMM [de] YYYY"))
    : (hitoDestacado?.valormin || fechaCierreLegible);
  const hitoHoraStr = hitoDestacado?.clave === "Cierre" && horaCierreLegible ? horaCierreLegible : "";
  const hitoConector = hitoFechaStr
    ? hitoFechaStr.toLowerCase().startsWith("una vez")
      ? ` - ${hitoFechaStr}`
      : ` el ${hitoFechaStr}`
    : "";

  const resolucionDoc = (props.convocatorias?.documentos_generales || []).find(
    (d: any) =>
      d.url_documento &&
      (d.tipo_documento === "Resolución" ||
        (d.descripcion && d.descripcion.toLowerCase().includes("resoluci")) ||
        (d.nombre && d.nombre.toLowerCase().includes("resoluci")) ||
        (d.descripcion && d.descripcion.toLowerCase().includes("otorgamiento")) ||
        (d.nombre && d.nombre.toLowerCase().includes("otorgamiento")))
  );

  const hitoDoc = hitoDestacado
    ? findDocumentoForActividad(hitoDestacado.clave) || (!esHitoFuturo ? resolucionDoc : null)
    : resolucionDoc;

  const etapasConfig = [
    { key: "apertura", title: "APERTURA E INSCRIPCIÓN" },
    { key: "verificacion", title: "PROCESO DE VERIFICACIÓN" },
    { key: "evaluacion", title: "EVALUACIÓN Y SELECCIÓN" },
  ];

  // Formato abreviado para mobile (ej: 400M)
  const formatMontoAbbr = (valor: any) => {
    const num = Number(valor);
    if (!num || isNaN(num) || num <= 0) return null;
    if (num >= 1000000000) {
      const b = num / 1000000000;
      return `$${b % 1 === 0 ? b : b.toFixed(1)}B`;
    }
    if (num >= 1000000) {
      const m = num / 1000000;
      return `$${m % 1 === 0 ? m : m.toFixed(1)}M`;
    }
    if (num >= 1000) {
      const k = num / 1000;
      return `$${k % 1 === 0 ? k : k.toFixed(1)}K`;
    }
    return `$${num.toLocaleString("es-CO")}`;
  };

  // Métricas para el banner azul oscuro (solo lo existente)
  const metricMonto = props.convocatorias?.valor_total_entg && Number(props.convocatorias.valor_total_entg) > 0
    ? `$${Number(props.convocatorias.valor_total_entg).toLocaleString("es-CO")}`
    : null;
  const metricMontoAbbr = formatMontoAbbr(props.convocatorias?.valor_total_entg);

  const metricEstimulos = props.convocatorias?.num_estimulos && Number(props.convocatorias.num_estimulos) > 0
    ? `${props.convocatorias.num_estimulos}`
    : null;

  const catCount = props.convocatorias?.categorias?.length || props.convocatorias?.categoria_linea_convocatoria?.length;
  const metricCategorias = catCount && catCount > 0 ? `${catCount}` : null;

  const metricCierre = fechaCierreLegible || null;

  // Configuración de perfiles para selector en tab "¿Qué necesito?"
  // Configuración de perfiles para selector en tab "¿Qué necesito?"
  const docsAdm = props.convocatorias?.documentos_administrativos || [];
  const tiposParticipante = Array.isArray(props.convocatorias?.tipo_participante)
    ? props.convocatorias.tipo_participante
    : [];

  const allProfiles = [
    {
      key: "0",
      label: "Persona natural",
      icon: <PersonIcon />,
      matches: (doc: any) => String(doc.tipo_persona) === "0",
      isInConvocatoria: tiposParticipante.some((t: any) => {
        const txt = String(t?.text ?? t?.nombre ?? t?.descripcion ?? (typeof t === "string" ? t : "")).toLowerCase();
        const val = Number(t?.value ?? t?.id ?? (typeof t === "number" ? t : NaN));
        return (
          txt.includes("natural") ||
          (!txt.includes("jurid") && !txt.includes("grupo") && !txt.includes("colectiv") && (val === 1 || val === 0))
        );
      }),
    },
    {
      key: "2",
      label: "Grupo conformado",
      icon: <GroupIcon />,
      matches: (doc: any) => String(doc.tipo_persona) !== "0" && String(doc.tipo_persona) !== "1",
      isInConvocatoria: tiposParticipante.some((t: any) => {
        const txt = String(t?.text ?? t?.nombre ?? t?.descripcion ?? (typeof t === "string" ? t : "")).toLowerCase();
        const val = Number(t?.value ?? t?.id ?? (typeof t === "number" ? t : NaN));
        return (
          txt.includes("grupo") ||
          txt.includes("colectivo") ||
          (!txt.includes("natural") && !txt.includes("jurid") && val === 3)
        );
      }),
    },
    {
      key: "1",
      label: "Persona jurídica",
      icon: <BuildingIcon />,
      matches: (doc: any) => String(doc.tipo_persona) === "1",
      isInConvocatoria: tiposParticipante.some((t: any) => {
        const txt = String(t?.text ?? t?.nombre ?? t?.descripcion ?? (typeof t === "string" ? t : "")).toLowerCase();
        const val = Number(t?.value ?? t?.id ?? (typeof t === "number" ? t : NaN));
        return (
          txt.includes("jurídica") ||
          txt.includes("juridica") ||
          (!txt.includes("natural") && !txt.includes("grupo") && !txt.includes("colectiv") && val === 2)
        );
      }),
    },
  ];

  const availablePersonas = allProfiles
    .filter((p) => {
      if (tiposParticipante.length > 0) {
        return p.isInConvocatoria;
      }
      return docsAdm.some(p.matches);
    })
    .map((p) => ({
      ...p,
      count: docsAdm.filter(p.matches).length,
    }));

  const activeProfilesList =
    availablePersonas.length > 0
      ? availablePersonas
      : allProfiles
          .filter((p) => docsAdm.some(p.matches))
          .map((p) => ({ ...p, count: docsAdm.filter(p.matches).length }));

  useEffect(() => {
    if (activeProfilesList.length > 0 && !activeProfilesList.some((p) => p.key === selectedPersona)) {
      setSelectedPersona(activeProfilesList[0].key);
    }
  }, [props.convocatorias?.tipo_participante, props.convocatorias?.documentos_administrativos]);

  // Tabs dinámicos basados exclusivamente en los datos existentes
  const availableTabs = [
    { id: "resumen", label: "Resumen" },
    ...(props.convocatorias?.tipo_participante?.length > 0 || props.convocatorias?.perfil_participante || props.convocatorias?.noparticipa
      ? [{ id: "quien_participa", label: "¿Quién puede participar?" }]
      : []),
    ...((props.convocatorias?.categorias && props.convocatorias.categorias.length > 0) || (props.convocatorias?.categoria_linea_convocatoria && props.convocatorias.categoria_linea_convocatoria.length > 0)
      ? [{ id: "categorias", label: "Categorías" }]
      : []),
    ...((props.convocatorias?.documentos_administrativos && props.convocatorias.documentos_administrativos.length > 0) || (props.convocatorias?.documentos_tecnicos && props.convocatorias.documentos_tecnicos.length > 0)
      ? [{ id: "requisitos", label: "¿Qué necesito?" }]
      : []),
    ...(props.convocatorias?.fechas && props.convocatorias.fechas.length > 0
      ? [{ id: "cronograma", label: "Cronograma" }]
      : []),
    ...((props.convocatorias?.documentos_generales && props.convocatorias.documentos_generales.length > 0) || props.convocatorias?.entidad === "SCC" || props.convocatorias?.entidad === "PDL y PPC"
      ? [{ id: "documentos", label: "Documentos" }]
      : []),
    ...(props.convocatorias?.documentos_generales?.some((d: any) => d.tipo_documento === "Informes") || correoAtencion
      ? [{ id: "informes", label: "Informes y avisos" }]
      : []),
  ];

  // Si la pestaña especificada en la URL no existe para esta convocatoria en particular, regresar a "resumen"
  useEffect(() => {
    if (availableTabs.length > 0) {
      const exists = availableTabs.some((t) => t.id === activeTab);
      if (!exists) {
        setActiveTab("resumen");
        updateTabUrl("resumen");
      }
    }
  }, [props.convocatorias?.idconvocatorias]);

  return (
    <div className="information-convocatoria-template">
      <Card className="card-detail-convocatoria">
        {/* Cabecera de la Convocatoria con Imagen de fondo difuminada y aclarada */}
        <div className="convocatoria-header-banner">
          <img
            src={dataImg || ImageNotFound}
            alt=""
            className="header-backdrop-img"
            aria-hidden="true"
          />
          <div className="header-backdrop-overlay" aria-hidden="true" />

          <div className="convocatoria-header-wrapper">
            <div className="header-content-grid">
              <div className="header-left-col">
                <div className="header-tags-row">
                  <span className={`status-pill ${statusInfo.classKey}`}>
                    <span className="status-dot"></span>
                    {statusInfo.label}
                  </span>
                  {(expresionVal || entidadVal) && (
                    <span className="meta-tag">
                      {expresionVal}
                      {expresionVal && entidadVal ? " · " : ""}
                      {entidadVal}
                    </span>
                  )}
                </div>

                <h1 className="convocatoria-main-title">{tituloPrincipal}</h1>

                {subtitulo && <div className="convocatoria-subtitle">{subtitulo}</div>}

                {fechaCierreLegible && (
                  <div className="convocatoria-closing-date">
                    Cierra el <strong>{fechaCierreLegible}{horaCierreLegible ? ` · ${horaCierreLegible}` : ""}</strong>
                  </div>
                )}

                {/* Cuenta regresiva de cierre */}
                {calculateDayEnd && timeRemaining.hasStarted && (
                  <div className={`countdown-timer-card ${timeRemaining.isFinished ? "is-closed" : "is-active"}`}>
                    <div className="countdown-header">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      <span>{timeRemaining.isFinished ? "Convocatoria cerrada" : "Tiempo restante para postularse:"}</span>
                    </div>

                    {!timeRemaining.isFinished ? (
                      <div className="countdown-digits-row">
                        {timeRemaining.months > 0 && (
                          <>
                            <div className="digit-box">
                              <span className="digit-val">{timeRemaining.months}</span>
                              <span className="digit-lbl">{timeRemaining.months === 1 ? "mes" : "meses"}</span>
                            </div>
                            <span className="digit-sep">:</span>
                          </>
                        )}
                        <div className="digit-box">
                          <span className="digit-val">{String(timeRemaining.days).padStart(2, "0")}</span>
                          <span className="digit-lbl">días</span>
                        </div>
                        <span className="digit-sep">:</span>
                        <div className="digit-box">
                          <span className="digit-val">{String(timeRemaining.hours).padStart(2, "0")}</span>
                          <span className="digit-lbl">horas</span>
                        </div>
                        <span className="digit-sep">:</span>
                        <div className="digit-box">
                          <span className="digit-val">{String(timeRemaining.minutes).padStart(2, "0")}</span>
                          <span className="digit-lbl">min</span>
                        </div>
                        <span className="digit-sep">:</span>
                        <div className="digit-box">
                          <span className="digit-val">{String(timeRemaining.seconds).padStart(2, "0")}</span>
                          <span className="digit-lbl">seg</span>
                        </div>
                      </div>
                    ) : (
                      <div className="closed-notice">
                        El periodo de postulaciones ha finalizado
                      </div>
                    )}
                  </div>
                )}

                {!props.isVisualizar && (
                  <div className="convocatoria-actions-row">
                    <Button
                      className="btn-primary-postular"
                      onClick={insrcribirme}
                      loading={loadingAplicar}
                    >
                      {user && user?.documento ? "Postularme" : "Iniciar sesión para postularme"}
                    </Button>

                    <Button
                      className={`btn-secondary-guardar ${isSaved ? "is-saved" : ""}`}
                      onClick={toggleGuardar}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill={isSaved ? "#1d4ed8" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                      </svg>
                      {isSaved ? "Convocatoria guardada" : "Guardar convocatoria"}
                    </Button>
                  </div>
                )}
              </div>

              <div className="header-right-col">
                <div className="header-image-container">
                  <img
                    src={dataImg || ImageNotFound}
                    alt={tituloPrincipal}
                    className="header-convocatoria-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Banner azul oscuro con métricas (solo lo existente) */}
        {(metricMonto || metricEstimulos || metricCategorias || metricCierre) && (
          <div className="convocatoria-metrics-banner">
            <div className="metrics-banner-container">
              {metricMonto && (
                <div className="metric-col">
                  <div className="metric-value">
                    <span className="desktop-metric">{metricMonto}</span>
                    <span className="mobile-metric">{metricMontoAbbr || metricMonto}</span>
                  </div>
                  <div className="metric-label">
                    <span className="desktop-metric">Monto total</span>
                    <span className="mobile-metric">Monto</span>
                  </div>
                </div>
              )}
              {metricEstimulos && (
                <div className="metric-col">
                  <div className="metric-value">{metricEstimulos}</div>
                  <div className="metric-label">Estímulos</div>
                </div>
              )}
              {metricCategorias && (
                <div className="metric-col">
                  <div className="metric-value">{metricCategorias}</div>
                  <div className="metric-label">Categorías</div>
                </div>
              )}
              {metricCierre && (
                <div className="metric-col">
                  <div className="metric-value">
                    <span className="desktop-metric">{metricCierre}</span>
                    <span className="mobile-metric">{fechaCierreCompact || metricCierre}</span>
                  </div>
                  <div className="metric-label">
                    <span className="desktop-metric">Fecha de cierre</span>
                    <span className="mobile-metric">Cierre</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Barra de Tabs por información */}
        <div className="convocatoria-tabs-wrapper">
          {canScrollLeft && <div className="tabs-fade-left" aria-hidden="true" />}
          {canScrollLeft && (
            <button
              type="button"
              className="tabs-scroll-arrow left"
              onClick={() => scrollTabs("left")}
              aria-label="Ver pestañas anteriores"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
          )}

          <div
            className="tabs-inner-container"
            ref={tabsContainerRef}
            onScroll={checkScroll}
          >
            {availableTabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`tab-nav-button ${activeTab === tab.id ? "active" : ""}`}
                onClick={(e) => handleTabClick(tab.id, e)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {canScrollRight && (
            <button
              type="button"
              className="tabs-scroll-arrow right"
              onClick={() => scrollTabs("right")}
              aria-label="Ver más pestañas"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          )}
          {canScrollRight && <div className="tabs-fade-right" aria-hidden="true" />}
        </div>

        {/* Contenido de la pestaña activa */}
        <div className="convocatoria-tab-content-area">
          {/* TAB 1: RESUMEN */}
          {activeTab === "resumen" && (
            <div>
              <h2 className="content-section-title">¿De qué trata esta convocatoria?</h2>
              <div className="content-lead-text">
                {props.convocatorias?.descripcion_corta || props.convocatorias?.objetivo || "Esta convocatoria busca fomentar y visibilizar las iniciativas culturales y artísticas del distrito."}
              </div>

              {props.convocatorias?.objetivo && props.convocatorias?.descripcion_corta && props.convocatorias?.objetivo !== props.convocatorias?.descripcion_corta && (
                <div style={{ marginBottom: "24px" }}>
                  <h3 style={{ fontSize: "17px", fontWeight: 700, color: "#1e293b", marginBottom: "8px" }}>
                    {tituloObjeto}
                  </h3>
                  <p style={{ fontSize: "14.5px", color: "#475569", lineHeight: 1.6, textAlign: "justify" }}>
                    {props.convocatorias.objetivo}
                  </p>
                </div>
              )}

              {/* 2 Tarjetas de resumen */}
              <div className="summary-cards-grid">
                {/* Tarjeta 1: ¿QUIÉN PUEDE PARTICIPAR? + Expresión debajo */}
                <div className="summary-card">
                  <div className="summary-card-header">¿QUIÉN PUEDE PARTICIPAR?</div>
                  <div className="summary-checklist">
                    {props.convocatorias?.tipo_participante && props.convocatorias.tipo_participante.length > 0 ? (
                      props.convocatorias.tipo_participante.map((tipo: any, idx: number) => (
                        <div key={idx} className="check-item">
                          <span className="check-icon">✓</span>
                          <span>{tipo.text}</span>
                        </div>
                      ))
                    ) : (
                      <div className="check-item">
                        <span className="check-icon">✓</span>
                        <span>Ver lineamientos para condiciones específicas de participación</span>
                      </div>
                    )}
                  </div>

                  <div className="summary-card-bottom-kv">
                    {expresionVal && (
                      <div className="kv-row">
                        <span className="kv-label">Expresión:</span>
                        <span className="kv-value">{expresionVal}</span>
                      </div>
                    )}
                    <div className="kv-row">
                      <span className="kv-label">Menores de edad:</span>
                      <span className="kv-value">
                        {props.convocatorias?.menor_edad ? "Sí participan" : "No (solo mayores de 18 años)"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Tarjeta 2: RECURSOS Y LÍNEA ESTRATÉGICA */}
                <div className="summary-card">
                  <div className="summary-card-header">RECURSOS Y LÍNEA ESTRATÉGICA</div>
                  <div className="summary-keyvalue-list">
                    {entidadVal && (
                      <div className="kv-row">
                        <span className="kv-label">Recursos:</span>
                        <span className="kv-value">{entidadVal}</span>
                      </div>
                    )}

                    {lineaEstrategicaVal && (
                      <div className="kv-row">
                        <span className="kv-label">Línea estratégica:</span>
                        <span className="kv-value">{lineaEstrategicaVal}</span>
                      </div>
                    )}

                    {props.convocatorias?.cobertura && (
                      <div className="kv-row">
                        <span className="kv-label">Cobertura:</span>
                        <span className="kv-value">{props.convocatorias.cobertura}</span>
                      </div>
                    )}

                    {props.convocatorias?.modalidad && (
                      <div className="kv-row">
                        <span className="kv-label">Modalidad:</span>
                        <span className="kv-value">{props.convocatorias.modalidad}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Banner de Próximo Hito / Último Hito */}
              {hitoDestacado && (
                <div className="proximo-hito-banner">
                  <div className="hito-left-info">
                    <span className="hito-tag">{hitoTitulo}</span>
                    <span className="hito-text">
                      <strong>{hitoNombre}</strong>{hitoConector}{hitoHoraStr ? ` a las ${hitoHoraStr}` : ""}
                    </span>
                  </div>

                  {hitoDoc && (
                    <button
                      type="button"
                      className="btn-hito-doc"
                      disabled={loadingDoc === hitoDoc.url_documento}
                      onClick={() => handleVerDocumento(hitoDoc.url_documento, hitoDoc.nombre || hitoDoc.descripcion)}
                      title={`Ver ${hitoDoc.nombre || hitoDoc.descripcion || "documento"} en línea`}
                    >
                      {loadingDoc === hitoDoc.url_documento ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: "13px", height: "13px", borderWidth: "2px", marginRight: "6px" }}></span>
                      ) : (
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      )}
                      <span>
                        {loadingDoc === hitoDoc.url_documento
                          ? "Cargando..."
                          : hitoDoc.tipo_documento === "Resolución" || (hitoDoc.nombre && hitoDoc.nombre.toLowerCase().includes("resoluci")) || (hitoDoc.descripcion && hitoDoc.descripcion.toLowerCase().includes("resoluci"))
                            ? "Ver resolución en línea"
                            : (hitoDoc.tipo_documento === "Informes" || (hitoDoc.nombre && hitoDoc.nombre.toLowerCase().includes("informe")) || (hitoDoc.descripcion && hitoDoc.descripcion.toLowerCase().includes("informe")))
                              ? "Ver informe en línea"
                              : "Ver documento en línea"}
                      </span>
                    </button>
                  )}
                </div>
              )}
            </div>
          )}

          {/* TAB 2: ¿QUIÉN PUEDE PARTICIPAR? */}
          {activeTab === "quien_participa" && (
            <div>
              <h2 className="content-section-title">¿Quién puede participar?</h2>

              <div className="profile-cards-container">
                {props.convocatorias?.tipo_participante && props.convocatorias.tipo_participante.length > 0 ? (
                  props.convocatorias.tipo_participante.map((tipo: any, idx: number) => {
                    const textLower = (tipo.text || "").toLowerCase();
                    let descripcion = "Participantes habilitados según las condiciones y requisitos establecidos en los lineamientos.";
                    if (textLower.includes("natural")) {
                      descripcion = "Personas mayores de edad con documento de identidad colombiano válido, que no tengan inhabilidades para contratar con el Estado.";
                    } else if (textLower.includes("grupo") || textLower.includes("colectivo")) {
                      descripcion = "Agrupaciones o colectivos conformados por dos o más personas que participan de manera conjunta. Deben designar un representante responsable.";
                    } else if (textLower.includes("jurídica") || textLower.includes("juridica")) {
                      descripcion = "Organizaciones con personería jurídica y NIT vigente, representadas por su representante legal o apoderado.";
                    }

                    return (
                      <div key={idx} className="profile-card-item">
                        <div className="profile-title">{tipo.text}</div>
                        <p className="profile-desc">{descripcion}</p>
                      </div>
                    );
                  })
                ) : (
                  <div className="profile-card-item">
                    <div className="profile-title">Participantes habilitados</div>
                    <p className="profile-desc">
                      {props.convocatorias?.perfil_participante || "Consulta los lineamientos para verificar los perfiles y requisitos específicos de participación."}
                    </p>
                  </div>
                )}

                {props.convocatorias?.perfil_participante && (
                  <div className="profile-card-item">
                    <div className="profile-title">Perfil específico del participante</div>
                    <p className="profile-desc">{props.convocatorias.perfil_participante}</p>
                  </div>
                )}

                <div className="profile-card-item">
                  <div className="profile-title">
                    Participación de menores de edad: {props.convocatorias?.menor_edad ? "Habilitada" : "No permitida"}
                  </div>
                  <p className="profile-desc">
                    {props.convocatorias?.menor_edad
                      ? "Esta convocatoria admite la participación de menores de edad bajo las condiciones, requisitos y autorizaciones estipuladas en los lineamientos."
                      : "Esta convocatoria está dirigida exclusivamente a personas mayores de 18 años cumplidos al momento de la postulación."}
                  </p>
                </div>
              </div>

              {/* Alerta de Importante */}
              <div className="importante-alert-box">
                <div className="importante-title">Importante</div>
                <p className="importante-text">
                  Los perfiles habilitados cambian según cada convocatoria. Consulta las condiciones específicas del lineamiento antes de iniciar tu postulación.
                </p>
                {props.convocatorias?.noparticipa && (
                  <div style={{ marginTop: "10px", fontSize: "14px", color: "#92400e", textAlign: "justify" }}>
                    <strong>Quiénes no pueden participar:</strong> {props.convocatorias.noparticipa}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* TAB 3: CATEGORÍAS */}
          {activeTab === "categorias" && (
            <div>
              <h2 className="content-section-title">Categorías de la convocatoria</h2>
              <div className="categories-grid">
                {(() => {
                  const rawCats =
                    props.convocatorias?.categoria_linea_convocatoria && props.convocatorias.categoria_linea_convocatoria.length > 0
                      ? props.convocatorias.categoria_linea_convocatoria
                      : props.convocatorias?.categorias && props.convocatorias.categorias.length > 0
                      ? props.convocatorias.categorias
                      : [];

                  if (!rawCats || rawCats.length === 0) {
                    return (
                      <Empty description="No hay categorías específicas registradas para esta convocatoria" />
                    );
                  }

                  return rawCats.map((cat: any, idx: number) => {
                    const nombre =
                      (typeof cat === "string" && cat.trim() !== "" ? cat : null) ||
                      cat?.text ||
                      cat?.nombre ||
                      cat?.name ||
                      cat?.nombre_categoria ||
                      cat?.descripcion ||
                      cat?.titulo ||
                      `Categoría ${idx + 1}`;

                    const descripcion =
                      cat?.descripcion && cat.descripcion !== nombre ? cat.descripcion : null;

                    const key =
                      cat?.value || cat?.id || cat?.idcategorialineaconvocatoria || idx;

                    return (
                      <div key={key} className="category-card">
                        <div>
                          <div className="category-name">{nombre}</div>
                          {descripcion && (
                            <div className="category-description">{descripcion}</div>
                          )}
                        </div>
                        {(cat?.num_estimulos || cat?.valor) && (
                          <div className="category-meta-row">
                            {cat.num_estimulos && (
                              <span className="cat-estimulos">{cat.num_estimulos} estímulos</span>
                            )}
                            {cat.valor && (
                              <span className="cat-monto">${Number(cat.valor).toLocaleString("es-CO")}</span>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  });
                })()}
              </div>
            </div>
          )}

          {/* TAB 4: ¿QUÉ NECESITO? (DOCUMENTACIÓN ADMINISTRATIVA Y TÉCNICA) */}
          {activeTab === "requisitos" && (
            <div>
              <h2 className="content-section-title">¿Qué necesito?</h2>
              {activeProfilesList.length > 1 ? (
                <div className="content-lead-text">
                  Selecciona tu tipo de participante para consultar los documentos administrativos requeridos para tu postulación:
                </div>
              ) : (
                <div className="content-lead-text">
                  Convocatoria dirigida a <strong>{activeProfilesList[0]?.label || "Persona natural"}</strong>. A continuación se detallan los documentos administrativos requeridos para tu postulación:
                </div>
              )}

              {/* Selector interactivo con iconos de Persona natural, Grupo conformado y Persona jurídica */}
              {activeProfilesList.length > 0 && (
                <div className="persona-selector-container">
                  <div className="persona-selector-grid">
                    {activeProfilesList.map((p) => (
                      <button
                        key={p.key}
                        type="button"
                        className={`persona-selector-btn ${selectedPersona === p.key ? "selected" : ""}`}
                        onClick={() => setSelectedPersona(p.key)}
                      >
                        <div className="persona-icon-circle">{p.icon}</div>
                        <div className="persona-info">
                          <div className="persona-name">{p.label}</div>
                          <div className="persona-docs-count">{p.count} documento{p.count === 1 ? "" : "s"}</div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Lista filtrada de documentos administrativos */}
              <div className="modern-table-wrapper">
                <div className="section-subtitle">
                  Documentación administrativa para {activeProfilesList.find((p) => p.key === selectedPersona)?.label || "este perfil"}
                </div>

                {(() => {
                  const currentProfile = activeProfilesList.find((p) => p.key === selectedPersona) || activeProfilesList[0];
                  const filteredDocs = docsAdm.filter(currentProfile ? currentProfile.matches : () => true);

                  if (!filteredDocs || filteredDocs.length === 0) {
                    return (
                      <Empty
                        description={`No se registran documentos administrativos específicos para ${currentProfile?.label || "este perfil"}`}
                        style={{ padding: "24px 0" }}
                      />
                    );
                  }

                  return (
                    <div className="docs-list-wrapper">
                      {filteredDocs.map((item: any, idx: number) => {
                        const isEnLinea = formulariosEnLinea.includes(item.descripcion);
                        const hasUrl = Boolean(!isEnLinea && item.url_documento && item.url_documento !== "");
                        const extension = hasUrl ? getDocExtension(item.url_documento, item.descripcion) : "";
                        const isDownloading = (loading && (loading[item.descripcion] || (item.nombre && loading[item.nombre]))) || false;
                        const isViewing = loadingDoc === item.url_documento;

                        return (
                          <div
                            key={item.id || idx}
                            className={`doc-item-card ${isEnLinea ? "is-en-linea" : hasUrl ? "has-file" : "user-provided"}`}
                          >
                            <div className="doc-item-main">
                              <div
                                className={`doc-item-icon-wrap ${
                                  isEnLinea
                                    ? "online-wrap"
                                    : hasUrl
                                    ? `file-${extension.toLowerCase()}`
                                    : "user-wrap"
                                }`}
                                aria-hidden="true"
                              >
                                {isEnLinea ? (
                                  <>
                                    <FormPencilIcon />
                                    <span className="doc-item-ext-tag online">EN LÍNEA</span>
                                  </>
                                ) : hasUrl ? (
                                  <>
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                      <polyline points="14 2 14 8 20 8" />
                                      <line x1="16" y1="13" x2="8" y2="13" />
                                      <line x1="16" y1="17" x2="8" y2="17" />
                                    </svg>
                                    <span className="doc-item-ext-tag">{extension}</span>
                                  </>
                                ) : (
                                  <>
                                    <ClipDocIcon />
                                    <span className="doc-item-ext-tag user">ADJUNTO</span>
                                  </>
                                )}
                              </div>

                              <div className="doc-item-info">
                                <div className="doc-title-row">
                                  <span className="doc-number-badge">{idx + 1}</span>
                                  <h4 className="doc-desc" title={item.descripcion}>
                                    {item.descripcion}
                                  </h4>
                                </div>

                                <div className="doc-badges-row">
                                  {isEnLinea ? (
                                    <>
                                      <span className="doc-badge badge-online">
                                        <span className="badge-dot" />
                                        Se diligencia en línea
                                      </span>
                                      <span className="doc-helper-text">
                                        Formulario digital que se completa durante la postulación
                                      </span>
                                    </>
                                  ) : hasUrl ? (
                                    <>
                                      <span className="doc-badge badge-template">Formato descargable</span>
                                      <span className="doc-badge badge-ext">{extension}</span>
                                      <span className="doc-helper-text">
                                        Descarga la plantilla oficial para diligenciarla
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <span className="doc-badge badge-user">Documento del participante</span>
                                      <span className="doc-helper-text">
                                        Documento a adjuntar en formato digital (PDF) al inscribirte
                                      </span>
                                    </>
                                  )}

                                  <span className="doc-badge badge-subsanable">
                                    Subsanable
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="doc-item-actions">
                              {isEnLinea ? (
                                <button
                                  type="button"
                                  className="doc-action-pill online is-clickable"
                                  onClick={insrcribirme}
                                  disabled={loadingAplicar}
                                  title="Este documento se diligencia en línea durante la postulación. Haz clic para aplicar ahora."
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12" />
                                  </svg>
                                  <span>En plataforma</span>
                                  <span className="pill-arrow-hint">· Aplicar →</span>
                                </button>
                              ) : hasUrl ? (
                                <>
                                  <button
                                    type="button"
                                    className="btn-doc-view"
                                    onClick={() => handleVerDocumento(item.url_documento, item.descripcion)}
                                    disabled={!item.url_documento || isViewing}
                                    title={`Ver ${item.descripcion}`}
                                  >
                                    {isViewing ? (
                                      <>
                                        <span className="btn-spinner" />
                                        <span>Abriendo...</span>
                                      </>
                                    ) : (
                                      <>
                                        <EyeIcon />
                                        <span>Ver</span>
                                      </>
                                    )}
                                  </button>

                                  <button
                                    type="button"
                                    className="btn-doc-download"
                                    onClick={() => descargarArchivo(item.url_documento, item.descripcion)}
                                    disabled={!item.url_documento || isDownloading}
                                    title={`Descargar ${item.descripcion}`}
                                  >
                                    {isDownloading ? (
                                      <>
                                        <span className="btn-spinner" />
                                        <span>Descargando...</span>
                                      </>
                                    ) : (
                                      <>
                                        <DownloadIcon />
                                        <span>Descargar</span>
                                      </>
                                    )}
                                  </button>
                                </>
                              ) : (
                                <button
                                  type="button"
                                  className="doc-action-pill user is-clickable"
                                  onClick={insrcribirme}
                                  disabled={loadingAplicar}
                                  title="Este documento se adjunta durante la postulación. Haz clic para aplicar ahora."
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="17 8 12 3 7 8" />
                                    <line x1="12" y1="3" x2="12" y2="15" />
                                  </svg>
                                  <span>Aportar en registro</span>
                                  <span className="pill-arrow-hint">· Aplicar →</span>
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })()}
              </div>

              {/* Documentación técnica */}
              {props.convocatorias?.documentos_tecnicos && props.convocatorias.documentos_tecnicos.length > 0 && (
                <div className="modern-table-wrapper" style={{ marginTop: "36px" }}>
                  <div className="section-subtitle">Documentación técnica</div>
                  <div className="docs-list-wrapper">
                    {props.convocatorias.documentos_tecnicos.map((item: any, idx: number) => {
                      const hasUrl = Boolean(item.url_documento && item.url_documento !== "");
                      const extension = hasUrl ? getDocExtension(item.url_documento, item.descripcion) : "DOC";
                      const isDownloading = (loading && (loading[item.descripcion] || (item.nombre && loading[item.nombre]))) || false;

                      return (
                        <div key={item.id || idx} className="doc-item-card has-file tech-card">
                          <div className="doc-item-main">
                            <div className={`doc-item-icon-wrap file-${extension.toLowerCase()}`} aria-hidden="true">
                              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                                <line x1="16" y1="13" x2="8" y2="13" />
                                <line x1="16" y1="17" x2="8" y2="17" />
                                <polyline points="10 9 9 9 8 9" />
                              </svg>
                              <span className="doc-item-ext-tag">{extension}</span>
                            </div>

                            <div className="doc-item-info">
                              <div className="doc-title-row">
                                <span className="doc-number-badge">{idx + 1}</span>
                                <h4 className="doc-desc" title={item.descripcion}>
                                  {item.descripcion}
                                </h4>
                              </div>

                              <div className="doc-badges-row">
                                <span className="doc-badge badge-tech">Formato técnico oficial</span>
                                <span className={`doc-badge badge-ext ext-${extension.toLowerCase()}`}>{extension}</span>
                                <span className="doc-badge badge-nosubsanable">No subsanable</span>
                                <span className="doc-helper-text">
                                  Plantilla requerida para la postulación técnica
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="doc-item-actions">
                            {hasUrl ? (
                              <button
                                type="button"
                                className="btn-doc-download"
                                onClick={() => descargarArchivo(item.url_documento, item.descripcion)}
                                disabled={!item.url_documento || isDownloading}
                                title={`Descargar ${item.descripcion}`}
                              >
                                {isDownloading ? (
                                  <>
                                    <span className="btn-spinner" />
                                    <span>Descargando...</span>
                                  </>
                                ) : (
                                  <>
                                    <DownloadIcon />
                                    <span>Descargar</span>
                                  </>
                                )}
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="doc-action-pill user is-clickable"
                                onClick={insrcribirme}
                                disabled={loadingAplicar}
                                title="Para aportar este documento técnico, haz clic para iniciar tu postulación."
                              >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                  <polyline points="17 8 12 3 7 8" />
                                  <line x1="12" y1="3" x2="12" y2="15" />
                                </svg>
                                <span>Aportar en registro</span>
                                <span className="pill-arrow-hint">· Aplicar →</span>
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* TAB 5: CRONOGRAMA */}
          {activeTab === "cronograma" && (
            <div>
              <div className="cronograma-header-container">
                <div>
                  <h2 className="content-section-title" style={{ marginBottom: "4px" }}>
                    Cronograma de actividades
                  </h2>
                  <p className="cronograma-header-subtitle">
                    Fechas clave del proceso. Puedes descargar el cronograma como imagen para guardarlo en tu teléfono.
                  </p>
                </div>

                {props.convocatorias?.fechas && props.convocatorias.fechas.length > 0 && (
                  <button
                    type="button"
                    className="btn-download-cronograma-img"
                    onClick={handleDescargarCronogramaImagen}
                    disabled={isGeneratingCronogramaImg}
                    title="Descargar cronograma como imagen para celular o compartir"
                  >
                    {isGeneratingCronogramaImg ? (
                      <>
                        <span className="btn-spinner" />
                        <span>Generando imagen...</span>
                      </>
                    ) : (
                      <>
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                          <line x1="12" y1="18" x2="12.01" y2="18" strokeWidth="3" />
                        </svg>
                        <span>Descargar para celular</span>
                      </>
                    )}
                  </button>
                )}
              </div>

              {props.convocatorias?.fechas && props.convocatorias.fechas.length > 0 ? (
                <div className="cronograma-tables-container">
                  {etapasConfig.map((etapa) => {
                    const itemsDeEtapa = fechasOrdenadas.filter(
                      (f: any) => getEtapaCronograma(f.clave) === etapa.key
                    );

                    if (itemsDeEtapa.length === 0) return null;

                    return (
                      <div key={etapa.key} className="cronograma-etapa-block">
                        <div className="cronograma-etapa-title">{etapa.title}</div>
                        <table className="cronograma-table">
                          <tbody>
                            {itemsDeEtapa.map((item: any, idx: number) => {
                              const fechaLim = getFechaMoment(item);
                              const matchingDoc = findDocumentoForActividad(item.clave);
                              const isPast = fechaLim.isValid() ? now.isAfter(fechaLim) : Boolean(matchingDoc);
                              const isCierre = item.clave === "Cierre";
                              const docLabel =
                                matchingDoc?.tipo_documento === "Resolución" ||
                                (matchingDoc?.nombre && matchingDoc.nombre.toLowerCase().includes("resoluci")) ||
                                (matchingDoc?.descripcion && matchingDoc.descripcion.toLowerCase().includes("resoluci"))
                                  ? "Ver resolución"
                                  : matchingDoc?.tipo_documento === "Informes" ||
                                    (matchingDoc?.nombre && matchingDoc.nombre.toLowerCase().includes("informe")) ||
                                    (matchingDoc?.descripcion && matchingDoc.descripcion.toLowerCase().includes("informe"))
                                    ? "Ver informe"
                                    : "Ver documento";

                              return (
                                <tr key={item.clave || idx}>
                                  <td className="cronograma-actividad-cell">
                                    <div className="actividad-content">
                                      {isPast && (
                                        <span className="check-done-icon" title="Actividad cumplida">✓</span>
                                      )}
                                      <span className="actividad-nombre">{item.clave}</span>
                                    </div>
                                  </td>
                                  <td className={`cronograma-fecha-cell ${isCierre ? "highlight-cierre" : ""}`}>
                                    <div className="fecha-content-row">
                                      <span className="fecha-texto">
                                        {formatFechaCronograma(item)}
                                      </span>

                                      {matchingDoc && (
                                        <button
                                          type="button"
                                          className="btn-ver-informe"
                                          disabled={loadingDoc === matchingDoc.url_documento}
                                          onClick={() => handleVerDocumento(matchingDoc.url_documento, matchingDoc.nombre || matchingDoc.descripcion)}
                                          title={`Ver ${matchingDoc.nombre || matchingDoc.descripcion || "documento"}`}
                                        >
                                          {loadingDoc === matchingDoc.url_documento ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: "12px", height: "12px", borderWidth: "2px", marginRight: "4px" }}></span>
                                          ) : (
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                              <circle cx="12" cy="12" r="3" />
                                            </svg>
                                          )}
                                          <span>{loadingDoc === matchingDoc.url_documento ? "Cargando..." : docLabel}</span>
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <Empty description="La convocatoria no cuenta con un cronograma de actividades registrado" />
              )}

              {/* Plantilla off-screen para generación de imagen de cronograma formato teléfono */}
              {props.convocatorias?.fechas && props.convocatorias.fechas.length > 0 && (
                <div
                  ref={cronogramaTemplateRef}
                  className="cronograma-phone-card"
                  style={{
                    position: "fixed",
                    left: "-9999px",
                    top: "0",
                    width: "480px",
                    zIndex: -9999,
                    pointerEvents: "none",
                  }}
                  aria-hidden="true"
                >
                  <div className="phone-card-inner">
                    {/* Header */}
                    <div className="phone-header">
                      <div className="phone-inst-badge">
                        ALCALDÍA DE MEDELLÍN • SECRETARÍA DE CULTURA CIUDADANA
                      </div>
                      <div className="phone-badge-pill">
                        <span className="dot-live" />
                        <span>CRONOGRAMA OFICIAL</span>
                      </div>

                      <h3 className="phone-convocatoria-title">
                        {props.convocatorias?.nombre_convocatoria || "Convocatoria de Fomento y Estímulos"}
                      </h3>

                      {/* Línea de convocatoria y Línea estratégica */}
                      <div className="phone-linea-box">
                        {getFilterLineaConvocatoria(props.convocatorias?.linea_convocatoria) ? (
                          <div className="phone-linea-item">
                            <span className="phone-linea-label">LÍNEA DE CONVOCATORIA:</span>
                            <span className="phone-linea-value">
                              {getFilterLineaConvocatoria(props.convocatorias?.linea_convocatoria)}
                            </span>
                          </div>
                        ) : null}

                        {props.convocatorias?.linea_estrategica ? (
                          <div className="phone-linea-item">
                            <span className="phone-linea-label">LÍNEA ESTRATÉGICA:</span>
                            <span className="phone-linea-value">
                              {props.convocatorias.linea_estrategica}
                            </span>
                          </div>
                        ) : null}

                        {props.convocatorias?.numero_convocatoria ? (
                          <div className="phone-linea-item">
                            <span className="phone-linea-label">CONVOCATORIA N°:</span>
                            <span className="phone-linea-value">
                              {props.convocatorias.numero_convocatoria}
                            </span>
                          </div>
                        ) : null}

                        <div className="phone-linea-item">
                          <span className="phone-linea-label">PARTICIPACIÓN DE MENORES:</span>
                          <span
                            className="phone-linea-value"
                            style={{ color: props.convocatorias?.menor_edad ? "#86efac" : "#fca5a5" }}
                          >
                            {props.convocatorias?.menor_edad
                              ? "Sí (permite menores de edad)"
                              : "No (solo mayores de 18 años)"}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Etapas y fechas */}
                    <div className="phone-body">
                      {etapasConfig.map((etapa, idx) => {
                        const itemsDeEtapa = fechasOrdenadas.filter(
                          (f: any) => getEtapaCronograma(f.clave) === etapa.key
                        );
                        if (itemsDeEtapa.length === 0) return null;

                        return (
                          <div key={etapa.key} className="phone-stage-section">
                            <div className="phone-stage-header">
                              <span className="phone-stage-number">{idx + 1}</span>
                              <span className="phone-stage-title">{etapa.title}</span>
                            </div>

                            <div className="phone-stage-items">
                              {itemsDeEtapa.map((item: any, itemIdx: number) => {
                                const isCierre = item.clave === "Cierre";
                                const fechaTexto = formatFechaCronograma(item);

                                return (
                                  <div
                                    key={item.clave || itemIdx}
                                    className={`phone-activity-row ${isCierre ? "highlight-cierre" : ""}`}
                                  >
                                    <div className="phone-activity-dot" />
                                    <div className="phone-activity-info">
                                      <span className="phone-activity-name">{item.clave}</span>
                                      <span className="phone-activity-date">{fechaTexto}</span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {/* Footer */}
                    <div className="phone-footer">
                      <div className="phone-footer-logo">
                        <span className="phone-footer-inst">Convocatoria de Fomento y Estímulos para el Arte y la Cultura</span>
                        <span className="phone-footer-portal">Medellín Me Cuida • www.medellin.gov.co</span>
                      </div>
                      <div className="phone-footer-note">
                        * Fechas oficiales sujetas a modificaciones por resolución. Consulta siempre la plataforma oficial.
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* TAB 6: DOCUMENTOS GENERALES, LINEAMIENTOS Y MANUALES */}
          {activeTab === "documentos" && (
            <div>
              <h2 className="content-section-title">Documentación e información a tener en cuenta</h2>

              {/* Lineamientos */}
              <div className="modern-table-wrapper">
                <div className="section-subtitle">Lineamientos</div>
                {renderDocumentCards(
                  props.convocatorias?.documentos_generales && Array.isArray(props.convocatorias.documentos_generales)
                    ? props.convocatorias.documentos_generales.filter((data: any) => data.tipo_documento === "Lineamiento")
                    : [],
                  "No hay lineamientos publicados para esta convocatoria",
                  "Los lineamientos oficiales se cargarán en esta sección cuando estén disponibles.",
                  (props.convocatorias?.entidad === "SCC" || props.convocatorias?.entidad === "PDL y PPC") ? (
                    <button
                      type="button"
                      className="btn-condiciones-generales"
                      onClick={mostrarModalCondiciones}
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                        <line x1="16" y1="17" x2="8" y2="17" />
                        <polyline points="10 9 9 9 8 9" />
                      </svg>
                      <span>Ver condiciones generales</span>
                    </button>
                  ) : null
                )}
              </div>

              {/* Resoluciones */}
              <div className="modern-table-wrapper">
                <div className="section-subtitle">Resoluciones</div>
                {renderDocumentCards(
                  props.convocatorias?.documentos_generales && Array.isArray(props.convocatorias.documentos_generales)
                    ? props.convocatorias.documentos_generales.filter((data: any) => data.tipo_documento === "Resolución")
                    : [],
                  "No hay resoluciones registradas para esta convocatoria",
                  "Las resoluciones oficiales serán publicadas en esta sección conforme avance el proceso."
                )}
              </div>

              {/* Manual de usuario */}
              <div className="modern-table-wrapper">
                <div className="section-subtitle">Manual de usuario</div>
                {renderDocumentCards(
                  props.convocatorias?.documentos_generales && Array.isArray(props.convocatorias.documentos_generales)
                    ? props.convocatorias.documentos_generales.filter((data: any) => data.tipo_documento === "Manual")
                    : [],
                  "No hay manuales registrados para esta convocatoria",
                  "El manual y guías para postulantes estarán disponibles en este espacio."
                )}
              </div>

              {/* Video tutorial (SM) */}
              {props.convocatorias?.entidad === "SM" && (
                <div className="modern-table-wrapper" style={{ marginTop: "24px" }}>
                  <div className="section-subtitle">Video tutorial</div>
                  <div style={{ maxWidth: "560px", marginTop: "12px" }}>
                    <iframe
                      src="https://drive.google.com/file/d/1MikaJ1UBAfWri50BSgKCZ1v-tS_uh5By/preview"
                      allow="autoplay"
                      allowFullScreen
                      loading="lazy"
                      title="Video tutorial de la convocatoria"
                      style={{ width: "100%", height: "315px", border: "none", borderRadius: "8px" }}
                    ></iframe>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* TAB 7: INFORMES Y ATENCIÓN CIUDADANA */}
          {activeTab === "informes" && (
            <div>
              <h2 className="content-section-title">Informes y avisos</h2>
              <div className="modern-table-wrapper">
                {renderDocumentCards(
                  props.convocatorias?.documentos_generales && Array.isArray(props.convocatorias.documentos_generales)
                    ? props.convocatorias.documentos_generales.filter((data: any) => data.tipo_documento === "Informes")
                    : [],
                  "No hay informes o avisos publicados para esta convocatoria",
                  "Los informes de verificación, subsanación y otorgamiento se publicarán en esta sección."
                )}
              </div>

              {correoAtencion && (
                <div className="summary-card" style={{ maxWidth: "600px", marginTop: "24px" }}>
                  <div className="summary-card-header">CANAL DE ATENCIÓN CIUDADANA</div>
                  <p style={{ fontSize: "14px", color: "#475569", marginBottom: "8px" }}>
                    Si tienes dudas o inquietudes sobre esta convocatoria, escribe al correo institucional:
                  </p>
                  <a
                    href={`mailto:${correoAtencion}`}
                    style={{ fontSize: "15px", fontWeight: 600, color: "#173365", wordBreak: "break-all" }}
                  >
                    {correoAtencion}
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </Card>

      {/* Barra sticky inferior con acciones y botón Regresar */}
      {!props.isVisualizar && (
        <div className="convocatoria-sticky-footer">
          <div className="footer-inner-container">
            <div>
              {props.convocatorias?.entidad === "SM" && (
                <button
                  type="button"
                  className="btn-regresar"
                  onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/mujeres"; }}
                >
                  REGRESAR
                </button>
              )}
              {props.convocatorias?.entidad === "SCC" && (
                <button
                  type="button"
                  className="btn-regresar"
                  onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/#convocatorias"; }}
                >
                  REGRESAR
                </button>
              )}
              {props.convocatorias?.entidad === "PP" && (
                <button
                  type="button"
                  className="btn-regresar"
                  onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/pp"; }}
                >
                  REGRESAR
                </button>
              )}
              {props.convocatorias?.entidad === "AGENDA PP" && (
                <button
                  type="button"
                  className="btn-regresar"
                  onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/ppagenda"; }}
                >
                  REGRESAR
                </button>
              )}
              {props.convocatorias?.entidad === "MCM" && (
                <button
                  type="button"
                  className="btn-regresar"
                  onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/mcm"; }}
                >
                  REGRESAR
                </button>
              )}
            </div>

            <Button
              className="btn-aplicar-footer"
              onClick={insrcribirme}
              loading={loadingAplicar}
            >
              {user && user?.documento ? "POSTULARME" : "APLICAR AHORA"}
            </Button>
          </div>
        </div>
      )}

      {/* Modales correspondientes */}
      {(props.convocatorias?.entidad === "SCC" || props.convocatorias?.entidad === "PDL y PPC") && (
        <div>
          <ModalCondicionesGenerales
            visualizar={visualizarCondiciones}
            setVisualizar={setVisualizarCondiciones}
            nombre={props.convocatorias?.linea_estrategica}
          />
          <ModalVisualizarAplicar
            visualizar={visualizarAplicar}
            setVisualizar={setVisualizarAplicar}
          />
        </div>
      )}

      <ModalVisualizarDocumentos
        visualizar={visualizarDocument}
        setVisualizar={setVisualizarDocument}
        state={{ documento: urldocumento }}
      />
    </div>
  );
};
